import styled from "styled-components/macro";

export const ImportCharactersContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  height: calc(100% - 113px); // subtracting the header and footer height
  .inputs {
    margin-top: 32px;
    display: flex;
    flex-direction: row;
    gap: 20px;
    flex-grow: 1;
    height: 100%;

    textarea {
      box-sizing: border-box;
      height: 100%;
      width: calc(50% - 10px); // subtracting half the gap (20px)
      resize: none;
      border: 1px solid var(--grey-3);
      background: var(--document-background);
      border-radius: 5px;
      box-shadow: var(--tiny-drop-shadow);
      padding: 8px 13px;
      font-family: "Inter";
      font-size: 16px;
      line-height: 1.3;
      color: var(--grey-0);

      &:focus {
        border-color: var(--primary-cta-high-contrast);
      }

      &.disabled {
        opacity: 0.5;
        pointer-events: none;
      }
    }
  }

  .validation {
    text-align: left;
    height: 100%;
    display: flex;
    flex-direction: column;

    // makes it so that the detected characters list doesn't cause the document section to shrink when it's really long
    > div:first-child {
      flex-shrink: 0;
    }

    .validation-heading {
      font-weight: 500;
      margin-bottom: 10px;
      color: var(--grey-0);
    }

    .validation-section {
      margin-top: 32px;
      display: flex;
      flex-direction: column;
      overflow: auto;
    }

    .detected-characters-list {
      display: flex;
      flex-direction: row;
      gap: 10px;
      flex-wrap: wrap;
      overflow-y: scroll;
      overflow-x: hidden;
      scrollbar-color: var(--scrollbar-thumb) var(--scrollbar-track);
      &::-webkit-scrollbar {
        width: 8px;
      }
      &::-webkit-scrollbar-track {
        background: var(--scrollbar-track);
      }
      &::-webkit-scrollbar-thumb {
        background-color: var(--scrollbar-thumb);
        border-radius: 5px;
      }
      &::-webkit-scrollbar-thumb:hover {
        background-color: var(--scrollbar-thumb-hover);
      }
    }
  }

  .error {
    margin-top: 32px;
    display: flex;
    justify-content: baseline;
    gap: 10px;
  }
`;

export const ModalInnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: 100%;
  overflow: hidden;
  width: 100%;

  .header {
    .header__title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;

      .main-title {
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 1.3;
        color: var(--grey-0);
      }

      .sub-title {
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 1.3;
        color: var(--grey-1);
      }
    }
    .close {
      position: absolute;
      top: 10px;
      right: 18px;
      cursor: pointer;

      svg {
        g {
          opacity: 1;
        }
      }
    }
  }

  .footer {
    margin-top: 15px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;

    .info-container {
      font-size: 14px;
      text-align: left;
      color: var(--grey-1);
      line-height: 1.3;

      button.link {
        color: var(--grey-1);
        font-size: 14px;
        text-decoration: underline;
        border: 0;
        background: none;
        cursor: pointer;
      }
    }

    .button-container {
      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        font-size: 16px;
        background: var(--primary-cta);
        color: var(--cta-text-color);
        border: 0;
        border-radius: 8px;
        font-family: Inter;
        font-weight: 500;
        padding: 8px 10px;
        cursor: pointer;
        text-decoration: none;
        text-align: center;

        &.disabled {
          background: var(--primary-cta-transparent-15);
          cursor: not-allowed;
          pointer-events: none;
        }

        &.secondary {
          background: var(--grey-3);
          color: var(--grey-2);
        }

        svg {
          path {
            stroke: var(--cta-text-color);
          }
        }
      }

      .keyboard-shortcut-container {
        display: flex;
        align-items: center;
        gap: 3px;

        svg.keyboard-shortcut {
          border: 2px solid rgba(225, 225, 225, 0.4);
          border-radius: 5px;
          path {
            fill: var(--cta-text-color);
            stroke: none;
          }
        }
      }
    }

    a.text-button-link {
      display: flex;
      align-items: center;
      justify-content: space-around;
      gap: 3px;
      color: var(--primary-cta-high-contrast);
      transition: all 0.2s ease-in-out;
      font-weight: 500;
      padding: 8px 10px;

      svg {
        path {
          fill: var(--primary-cta-high-contrast);
        }
      }

      &:hover {
        border-radius: 8px;
        background-color: var(--menu-color-fullscreen-hover);
      }

      &:active {
        background-color: var(--menu-color-active);
      }
    }
  }
`;
